import { useState, useMemo } from "react";
import { Toggle } from "components/atoms";

const AddtionalSetting = ({ label, desc, icon, content, isToggel, statusToggle }) => {
  const [toggle, setToggle] = useState(statusToggle);
  const handleToggle = (e) => {
    setToggle(!toggle)
    isToggel(!toggle)
  }

  useMemo(() => {
    setToggle(statusToggle)
  }, [statusToggle])

  return (
    <div className=" border-2 border-gray-culture rounded-md p-4 mb-2 ">
      <div className="flex justify-between items-center">
        <div className="flex items-center mr-4">
          <div className="w-10 h-10 mr-4 rounded-md bg-gray-culture flex justify-center items-center">
            {icon ? icon : "Icon"}
          </div>
          <div>
            <h3 className="bold-text-2">{label}</h3>
            <p className="text-sm">{desc}</p>
          </div>
        </div>
        <Toggle onChange={handleToggle} checked={toggle} />
      </div>

      {toggle && (
        <div className={`${toggle ? "border-t border-gray-culture" : ""} " mt-6 p-2 "`}>
          {content}
        </div>
      )}
    </div>
  );
};

export default AddtionalSetting;
